import { Select, type SelectProps } from '@aigc/antd';
import type { PrimaryKey, SafeAny } from '@aigc/types';
import { useQuery } from '@tanstack/react-query';
import { getSellingPointLookupQueryOptions } from '../api';

export const SellingPointSelect = (props: SelectProps<PrimaryKey>) => {
  const { data = [], isFetching } = useQuery(getSellingPointLookupQueryOptions);

  return (
    <Select
      {...props}
      loading={isFetching}
      onChange={props.onChange as SafeAny}
      options={data.map((item) => ({
        label: item.name,
        value: item.id,
      }))}
    />
  );
};
